/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const LtiUnsetDeadlineLockDateEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('LTI_UNSET_DEADLINE_LOCK_DATE_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class LtiUnsetDeadlineLockDateEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return LtiUnsetDeadlineLockDateEnabledSettingParser.decode(input).map(res => new LtiUnsetDeadlineLockDateEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return LtiUnsetDeadlineLockDateEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LtiUnsetDeadlineLockDateEnabledSettingParser.encode(data);
    }
    static schema() {
        return LtiUnsetDeadlineLockDateEnabledSettingParser.schema();
    }
}
